/* Inline SVG icons - avoids an icon-font dependency and keeps the bundle small.
 * All inherit currentColor so they follow the theme automatically. */

type P = { size?: number }
const base = (size: number) => ({
  width: size, height: size, viewBox: '0 0 24 24',
  fill: 'none', stroke: 'currentColor', strokeWidth: 1.7,
  strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const,
})

export const HomeIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M3 10.5 12 3l9 7.5" /><path d="M5.5 9.5V20h13V9.5" /><path d="M9.5 20v-6h5v6" /></svg>
)
export const ChartIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M3 21h18" /><rect x="5" y="11" width="3.6" height="7" rx="1" /><rect x="10.2" y="6" width="3.6" height="12" rx="1" /><rect x="15.4" y="13" width="3.6" height="5" rx="1" /></svg>
)
export const BellIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M18 8.5a6 6 0 1 0-12 0c0 5-2 6.5-2 6.5h16s-2-1.5-2-6.5Z" /><path d="M10.3 19a2 2 0 0 0 3.4 0" /></svg>
)
export const IdIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><rect x="2.5" y="5" width="19" height="14" rx="2.5" /><circle cx="8.5" cy="11" r="2" /><path d="M5.5 16c.6-1.4 1.7-2.1 3-2.1s2.4.7 3 2.1" /><path d="M14.5 10h4M14.5 13.5h4" /></svg>
)
export const ShieldIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M12 3 4.5 6v6c0 4.4 3.1 7.9 7.5 9 4.4-1.1 7.5-4.6 7.5-9V6L12 3Z" /><path d="m9 12 2 2 4-4" /></svg>
)
export const AlertIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M12 3 2 20h20L12 3Z" /><path d="M12 10v4" /><path d="M12 17.5h.01" /></svg>
)
export const UserIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><circle cx="12" cy="8" r="3.6" /><path d="M4.5 20c.9-3.6 3.9-5.6 7.5-5.6s6.6 2 7.5 5.6" /></svg>
)
export const LogOutIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M9 20H5.5A1.5 1.5 0 0 1 4 18.5v-13A1.5 1.5 0 0 1 5.5 4H9" /><path d="m15.5 8 4 4-4 4" /><path d="M19.5 12H9" /></svg>
)
export const MenuIcon = ({ size = 20 }: P) => (
  <svg {...base(size)}><path d="M4 7h16M4 12h16M4 17h16" /></svg>
)
export const CloseIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="m6 6 12 12M18 6 6 18" /></svg>
)
export const SunIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><circle cx="12" cy="12" r="4" /><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.2 5.2l1.4 1.4M17.4 17.4l1.4 1.4M18.8 5.2l-1.4 1.4M6.6 17.4l-1.4 1.4" /></svg>
)
export const MoonIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M20 13.5A8 8 0 1 1 10.5 4a6.5 6.5 0 0 0 9.5 9.5Z" /></svg>
)
export const PlusIcon = ({ size = 17 }: P) => (
  <svg {...base(size)}><path d="M12 5v14M5 12h14" /></svg>
)
export const DocIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M14 3H7a1.8 1.8 0 0 0-1.8 1.8v14.4A1.8 1.8 0 0 0 7 21h10a1.8 1.8 0 0 0 1.8-1.8V7.8L14 3Z" /><path d="M13.6 3.2V8h4.8" /></svg>
)
export const CheckIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="m5 12.5 4.5 4.5L19 7.5" /></svg>
)
export const InboxIcon = ({ size = 22 }: P) => (
  <svg {...base(size)}><path d="M3.5 13.5h4l1.5 3h6l1.5-3h4" /><path d="M5.4 5.5h13.2l1.9 8v4a2 2 0 0 1-2 2H5.5a2 2 0 0 1-2-2v-4l1.9-8Z" /></svg>
)
export const UsersGroupIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><circle cx="8.5" cy="8" r="3" /><path d="M2.5 19c.8-3.2 3.2-5 6-5s5.2 1.8 6 5" /><circle cx="17" cy="8.5" r="2.3" /><path d="M15.5 13.6c2.2.2 4 1.7 4.6 4.4" /></svg>
)
export const GradCapIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M2 9.5 12 5l10 4.5-10 4.5-10-4.5Z" /><path d="M6 11.5v4.3c0 1.3 2.7 2.4 6 2.4s6-1.1 6-2.4v-4.3" /><path d="M20 9.5v6" /></svg>
)
export const TruckIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><rect x="2" y="7" width="12" height="9" rx="1" /><path d="M14 10h4l3.5 3.5V16h-7.5" /><circle cx="7" cy="17.5" r="1.7" /><circle cx="17" cy="17.5" r="1.7" /></svg>
)
export const WrenchIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="M14.5 6.5a4 4 0 0 0-5.4 4.7L3 17.3l2.7 2.7 6.1-6.1a4 4 0 0 0 4.7-5.4l-2.9 2.9-2.4-.9-.9-2.4 2.9-2.9Z" /></svg>
)
export const RouteIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><circle cx="5.5" cy="6" r="2" /><circle cx="18.5" cy="18" r="2" /><path d="M5.5 8v3a4 4 0 0 0 4 4h5a4 4 0 0 1 3.6 2.3" /></svg>
)
export const CoinIcon = ({ size = 18 }: P) => (
  <svg {...base(size)}><circle cx="12" cy="12" r="9" /><path d="M12 7v10M9.5 9.2c0-1.2 1.1-2.2 2.5-2.2s2.5 1 2.5 2c0 2.5-5 1.5-5 4 0 1 1.1 2 2.5 2s2.5-1 2.5-2.2" /></svg>
)
